export default __webpack_public_path__ + "static/media/mirukuruonline.967968bf.webp";